// Helper function to combine class names
export const classNames = (...classes) => classes.filter(Boolean).join(" ")
